import { render, staticRenderFns } from "./LoginAsExhibitorButton.vue?vue&type=template&id=2899b7b6"
import script from "./LoginAsExhibitorButton.vue?vue&type=script&lang=ts"
export * from "./LoginAsExhibitorButton.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports